import * as React from "react";

function SvgAttribution(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 89 82.5"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <g fill="#5EBE8A">
        <circle cx={67.662} cy={64.378} r={17.136} />
        <path d="M63.152 28.546c2.437-3.139 4.173-6.923 4.173-11.208 0-9.464-7.672-17.136-17.136-17.136-5.773 0-9.674 2.666-13.129 6.123-9.437 9.442 3.633 28.249-26.027 42.874-.761.297-1.496.647-2.2 1.045C3.635 53.187.125 58.763.125 65.162c0 9.464 7.672 17.136 17.136 17.136s17.136-7.672 17.136-17.136c0-.508-.009-2.144.025-2.458 2.842-26.193 23.564-27.502 28.73-34.158z" />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgAttribution);
